import { AssistChip, IconCopyOutline, IconPhoneOutline, Spacer, Toast, useToast } from '@zillow/constellation';
import { HiddenLGAndAbove, HiddenMDAndBelow } from '../../styles/styled-components';
import { getPhoneNumberScreenFormat } from '../../utils/formatters';
import { logError } from '@zg-rentals/log-error';

interface Props {
  phoneNumber?: string | null;
}

export function PhoneButton({ phoneNumber }: Props) {
  const { enqueueToast } = useToast();
  const phoneNumberFormatted = getPhoneNumberScreenFormat(phoneNumber);

  async function onClickCopy() {
    if (phoneNumberFormatted) {
      await navigator.clipboard
        .writeText(phoneNumberFormatted)
        .then(() => {
          return enqueueToast(<Toast appearance="success" body="Phone number copied" />);
        })
        .catch((err) => {
          logError({ error: err, context: 'PhoneButton onClickCopy error' });
          return enqueueToast(<Toast appearance="error" body="Unable to copy phone number. Please try again" />);
        });
    }
  }

  function onClickCall() {
    window.open(`tel:${phoneNumber}`);
  }

  return (
    phoneNumberFormatted && (
      <Spacer marginY="sm">
        <HiddenMDAndBelow>
          <AssistChip icon={<IconCopyOutline />} onClick={onClickCopy}>
            {phoneNumberFormatted}
          </AssistChip>
        </HiddenMDAndBelow>

        <HiddenLGAndAbove>
          <AssistChip icon={<IconPhoneOutline />} onClick={onClickCall}>
            Call
          </AssistChip>
        </HiddenLGAndAbove>
      </Spacer>
    )
  );
}
